export default "__VITE_ASSET__DuVlgTa5__"